import React from "react";
import { TimePicker } from "antd";
// import "antd/dist/antd.css";

const TimeDeparture = ({
  index,
  timeDeparture,
  touched,
  changeTimeDepartureInput,
}) => {
  return (
    <TimePicker
      className="form-control"
      style={{
        width: "98%",
        borderRadius: "4px",
        // border:
        //   touched.flightLegs &&
        //   touched.flightLegs[index].departureTime &&
        //   !timeDeparture[index].time &&
        //   "1px solid red",
      }}
      id={`flightLegs.return[${index}]departureTime`}
      name={`flightLegs.return[${index}]departureTime`}
      use24Hours
      value={timeDeparture[index].time}
      onChange={(time, timeString) =>
        changeTimeDepartureInput(time, timeString, index)
      }
      required
    />
  );
};

export default TimeDeparture;
